import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StatusErrorIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.38 16H11.62C11.2776 16 11 16.2776 11 16.62V17.38C11 17.7224 11.2776 18 11.62 18H12.38C12.7224 18 13 17.7224 13 17.38V16.62C13 16.2776 12.7224 16 12.38 16Z"
        fill={color}
      />
      <path
        d="M12.38 6H11.62C11.2776 6 11 6.27758 11 6.62V13.38C11 13.7224 11.2776 14 11.62 14H12.38C12.7224 14 13 13.7224 13 13.38V6.62C13 6.27758 12.7224 6 12.38 6Z"
        fill={color}
      />
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM12 22.25C6.35 22.25 1.75 17.65 1.75 12C1.75 6.35 6.35 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

StatusErrorIcon.displayName = 'StatusErrorIcon';
